import { ColorPartial } from "@mui/material/styles/createPalette";

declare module "@mui/material/styles" {
  interface TypeBackground {
    sidebar?: string;
  }

  interface Palette {
    blue: ColorPartial;
  }

  interface PaletteOptions {
    blue: ColorPartial;
  }
}

export const Grey = {
  "50": "#F2F2F2",
  "100": "#DBDBDC",
  "200": "#C4C3C5",
  "300": "#ADACAF",
  "400": "#969598",
  "500": "#7F7E81",
  "600": "#666468",
  "700": "#4C4B4E",
  "800": "#333234",
  "900": "#19191A",
};

export const Blue = {
  "50": "#E6F5FF",
  "100": "#B9E4FE",
  "200": "#8CD2FD",
  "300": "#5EC1FC",
  "400": "#31B0FC",
  "500": "#049EFB",
  "600": "#037FC9",
  "700": "#025F97",
  "800": "#023F64",
  "900": "#012032",
};

export const FountainBlue = {
  "50": "#f1fcfc",
  "100": "#cff8f5",
  "200": "#9ff0ec",
  "300": "#67e1e0",
  "400": "#37c8ca",
  "500": "#1fadb2",
  "600": "#15868c",
  "700": "#156a70",
  "800": "#165359",
  "900": "#17464a",
  "950": "#07282c",
};

export const Background = {
  default: "#EEEDF3",
  sidebar: "#AEC5CD",
};

export const Black = "#000";
export const White = "#fff";

export default {
  common: {
    black: Black,
    white: White,
  },
  grey: Grey,
  blue: Blue,
  background: Background,
  primary: {
    main: FountainBlue["500"],
    light: FountainBlue["300"],
    dark: FountainBlue["700"],
    contrastText: White,
  },
  text: {
    primary: "#1D1D1D",
    secondary: Grey[600],
    disabled: Grey[400],
  },
};
